import AppForm from "@/app/components/atomic/AppForm"
import Filter, { FilterSkeleton } from "@/app/components/auctor/filter/Filter"
import { FILTER_COL_SPAN_HALF, FilterVariant, IAppliedFilter, IFilterConfig } from "@/app/models/auctor"
import { getFilterDisplayCondition } from "@/app/utils/filters-utils"

interface FilterListProps {
    filtersConfig: any
    appliedFilters: IAppliedFilter[]
    className?: string
    updateAppliedFilter: any
    displayNumberOnMobile?: number
    isFilterListExpandedOnMobile?: boolean
    queryParams?: Record<string, string> | null
    variant?: FilterVariant
}

const getToolFilterWidthClass = (filter: IFilterConfig) =>
    filter.col_span === FILTER_COL_SPAN_HALF ? "md:col-span-1" : "md:col-span-2"

export default function FilterList({
    filtersConfig,
    appliedFilters,
    updateAppliedFilter,
    className = "",
    displayNumberOnMobile = 2,
    isFilterListExpandedOnMobile = false,
    queryParams = null,
    variant = "default",
}: FilterListProps) {
    const getFilterClassName = (filter: IFilterConfig) => (variant === "tool" ? getToolFilterWidthClass(filter) : "")

    const filtersToDisplayOnBothDevices = filtersConfig?.slice(0, displayNumberOnMobile)
    const filtersToHideOnMobile = filtersConfig?.slice(displayNumberOnMobile)

    return (
        <AppForm className={className} dataTest="filter-list">
            {filtersToDisplayOnBothDevices?.map((filter: any, idx: number) => {
                if (getFilterDisplayCondition(filter, appliedFilters, queryParams)) {
                    const appliedFilter = appliedFilters.find((f) => f.filterId === filter.unique_id)
                    return (
                        <Filter
                            key={`filter-${filter.unique_id}`}
                            filterConfig={filter}
                            // @ts-ignore because if we have a filter we have an applied filter
                            appliedFilter={appliedFilter}
                            updateAppliedFilter={updateAppliedFilter}
                            variant={variant}
                            className={getFilterClassName(filter)}
                        />
                    )
                }
            })}

            {filtersToHideOnMobile?.map((filter: any, idx: number) => {
                if (getFilterDisplayCondition(filter, appliedFilters, queryParams)) {
                    const appliedFilter = appliedFilters.find((f) => f.filterId === filter.unique_id)
                    return (
                        // display:contents rend l'enveloppe transparente pour le flex parent : masquer sur mobile sans reflow.
                        <div
                            key={`filter-wrapper-${filter.unique_id}`}
                            className={isFilterListExpandedOnMobile ? "contents" : "hidden md:contents"}
                        >
                            <Filter
                                filterConfig={filter}
                                // @ts-ignore because if we have a filter we have an applied filter
                                appliedFilter={appliedFilter}
                                updateAppliedFilter={updateAppliedFilter}
                                variant={variant}
                                className={getFilterClassName(filter)}
                            />
                        </div>
                    )
                }
            })}
        </AppForm>
    )
}

export function FiltersSkeleton({
    countDesktop = 3,
    countAllDisplays = 2,
    countMobile = 2,
}: {
    countDesktop?: number
    countAllDisplays?: number
    countMobile?: number
}) {
    return (
        <>
            {Array.from(Array(countAllDisplays).keys())?.map((idx: number) => (
                <FilterSkeleton key={idx} />
            ))}

            {Array.from(Array(countDesktop).keys())?.map((idx: number) => (
                <FilterSkeleton className="hidden lg:block" key={idx} />
            ))}
        </>
    )
}
